import { useEffect, useState } from "react";

function queryWantsApp(): boolean {
  try {
    const app = new URLSearchParams(window.location.search).get("app");
    return app === "1" || app === "mobile";
  } catch {
    return false;
  }
}

/** True in the Flutter WebView (and when ?app=1 is used for local preview). */
export function isNativeApp(): boolean {
  if (typeof window === "undefined") return false;
  if (document.documentElement.classList.contains("is-native-app-forced")) return true;
  if (/\bDashcamApp\b/i.test(navigator.userAgent || "")) return true;
  return queryWantsApp();
}

export function syncNativeAppClass(on = isNativeApp()): boolean {
  if (typeof document === "undefined") return on;
  document.documentElement.classList.toggle("is-native-app", on);
  return on;
}

/** Keep focused inputs on screen when the mobile keyboard opens. */
export function attachNativeKeyboardAssist(): () => void {
  if (typeof window === "undefined") return () => {};
  const onResize = () => {
    const el = document.activeElement;
    if (!(el instanceof HTMLInputElement) && !(el instanceof HTMLTextAreaElement)) return;
    try {
      el.scrollIntoView({ block: "center", inline: "nearest" });
    } catch {
      /* ignore */
    }
  };
  const vp = window.visualViewport;
  vp?.addEventListener("resize", onResize);
  window.addEventListener("focusin", onResize);
  return () => {
    vp?.removeEventListener("resize", onResize);
    window.removeEventListener("focusin", onResize);
  };
}

export function useNativeApp(): boolean {
  const [native, setNative] = useState(() => syncNativeAppClass());

  useEffect(() => {
    setNative(syncNativeAppClass());
  }, []);

  useEffect(() => {
    if (!native) return;
    return attachNativeKeyboardAssist();
  }, [native]);

  return native;
}
